// src/components/EventStepper.tsx
import React from 'react';
import {
    Stepper,
    Step,
    StepIndicator,
    stepClasses,
    stepIndicatorClasses,
} from '@mui/joy';
import { Check } from '@mui/icons-material';
import { useEventForm } from '../context/EventFormContext';
import { useTranslation } from 'react-i18next';

const EventStepper: React.FC = () => {
    const { step } = useEventForm();
    const { t } = useTranslation();

    return (
        <Stepper
            size="lg"
            className="!mb-5 !mt-4"
            sx={{
                [`& .${stepIndicatorClasses.root}`]: {
                    backgroundColor: '#d7d7d7',
                },
                [`& .${stepClasses.root}::after`]: {
                    height: 2,
                },
                [`& .${stepClasses.completed}`]: {
                    [`& .${stepIndicatorClasses.root}`]: {
                        borderColor: '#343a9c',
                        bgcolor: '#343a9c',
                    },
                    '&::after': {
                        bgcolor: '#343a9c',
                    },
                },
            }}
        >
            <Step
                active={step === 1}
                completed={step > 1}
                indicator={
                    <StepIndicator variant={step <= 1 ? 'soft' : 'solid'}>
                        {step <= 1 ? 1 : <Check />}
                    </StepIndicator>
                }
            >
                <span className="text-sm">{t("Informations sur l'évènement")}</span>
            </Step>

            <Step
                active={step === 2}
                completed={step > 2}
                indicator={
                    <StepIndicator variant={step <= 2 ? 'soft' : 'solid'}>
                        {step <= 2 ? 2 : <Check />}
                    </StepIndicator>
                }
            >
                <span className="text-sm">{t("Lieu de l'évènement")}</span>
            </Step>

            <Step
                active={step === 3}
                completed={step > 3}
                indicator={
                    <StepIndicator variant={step <= 3 ? 'soft' : 'solid'}>
                        {step <= 3 ? 3 : <Check />}
                    </StepIndicator>
                }
            >
                <span className="text-sm">{t('Catégories')}</span>
            </Step>

            <Step
                active={step === 4}
                completed={step > 4}
                indicator={
                    <StepIndicator variant={step <= 4 ? 'soft' : 'solid'}>
                        {step <= 4 ? 4 : <Check />}
                    </StepIndicator>
                }
            >
                <span className="text-sm">{t('Artistes')}</span>
            </Step>
        </Stepper>
    );
};

export default EventStepper;